import { useEffect, useState } from 'react';

function useDebounceVar(value: string, wait = 500) {
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceValue(value);
    }, wait);
    return () => clearTimeout(timer);
  }, [value, wait]);

  return debounceValue;
}

export default useDebounceVar;
